module.exports = __webpack_public_path__ + "img/icon_home.c808fa65.png";